import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCalendars() {
  const [calendars, setCalendars] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.users.calendars.index)
      .then((response) => {
        setCalendars(response.data.data);
      });
  }, []);

  return calendars;
}
